import React, { VFC } from 'react';
import {
  Col,
  Container,
  Row,
  useScreenClass,
  Visible,
} from 'react-grid-system';

import styled from 'styled-components';
import { useReturnContext } from '../../contexts/returnContext';
import { useSettings } from '../../contexts/settingsContext';

import { theme } from '../../utils/theme';
import { IconVariants } from '../atoms/icons/types';
import Spacing from '../atoms/Spacing';
import Typography from '../atoms/Typography';
import ProductBasket from '../organisms/ProductBasket';
import IconButton from './IconButton';
import PrimaryButton from './PrimaryButton';

export interface IButton {
  icon: IconVariants;
  title: string;
  onClick: () => void;
  translateParams?: Record<string, unknown>;
}
interface IHeader {
  title: string;
  buttonLeft?: IButton;
  buttonRight?: IButton;
}

interface Props {
  radius: string;
}

const CustomContainer = styled(Container)<Props>`
  border-radius: ${({ radius }) => `${radius}`};
  border: 1px solid #e0e0e0;
  margin-bottom: 32px;
  margin-top: 32px;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const PageHeader: VFC<IHeader> = ({ title, buttonLeft, buttonRight }) => {
  const { showSpecificReturn, showTotalNumberOfItems } = useReturnContext();
  const { cornerRadius } = useSettings();
  const screenClass = useScreenClass();

  return (
    <>
      {buttonLeft && (
        <Visible xs sm md>
          <Spacing spacing={3} />
          <IconButton
            labelRight={buttonLeft.title}
            iconColor="black"
            icon={buttonLeft.icon ? buttonLeft.icon : 'arrow-left'}
            backgroundColor={theme.colors.grey[40]}
            onClick={buttonLeft.onClick}
          />
        </Visible>
      )}

      <CustomContainer radius={cornerRadius}>
        <Row nogutter justify="between" align="center">
          <Col sm={12} lg={4}>
            {buttonLeft && (
              <Visible lg xl xxl xxxl>
                <IconButton
                  labelRight={buttonLeft.title}
                  iconColor="black"
                  icon={buttonLeft.icon ? buttonLeft.icon : 'arrow-left'}
                  backgroundColor={theme.colors.grey[40]}
                  onClick={buttonLeft.onClick}
                />
              </Visible>
            )}
          </Col>

          <Col xs={12} sm={12} md={12} lg={4}>
            <Typography
              translateKey={title}
              align="center"
              variant={['lg', 'xl', 'xxl'].includes(screenClass) ? 'h2' : 'h3'}
            />
          </Col>
          <Col xs={12} sm={12} lg={4}>
            {buttonRight && (
              <Visible xs sm md>
                <Spacing spacing={2} />
              </Visible>
            )}
            <Row
              nogutter
              justify={
                ['lg', 'xl', 'xxl'].includes(screenClass) ? 'end' : 'center'
              }
            >
              {buttonRight && (
                <PrimaryButton
                  translateKey={buttonRight.title}
                  translateParams={buttonRight.translateParams}
                  icon={buttonRight.icon}
                  iconSize="large"
                  onClick={buttonRight.onClick}
                />
              )}
              {showSpecificReturn &&
              <ProductBasket showTotalNumberOfItems={showTotalNumberOfItems} />}
            </Row>
          </Col>
        </Row>
      </CustomContainer>
    </>
  );
};
export default PageHeader;
